
import { Vue, Options } from "vue-class-component";
import { EVENTS_COLORS } from "../config";
import { useStore } from "vuex";
import moment from "moment";

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

@Options({
  props: {
    showModal: Boolean,
    eventData: Object,
    mode: String
  },
  components: {
    Datepicker
  }
} as any)
export default class EventModal extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  globalStore = useStore();

  eventData!: any;
  mode!: string;
  uuid = this.eventData.uuid;
  title = this.eventData.title;
  content = this.eventData.content;
  start = {
    "hours": moment(this.eventData.start).format('HH:mm').split(':')[0],
    "minutes": moment(this.eventData.start).format('HH:mm').split(':')[1]
  }
  end = {
    "hours": moment(this.eventData.end).format('HH:mm').split(':')[0],
    "minutes": moment(this.eventData.end).format('HH:mm').split(':')[1]
  }
  color = this.eventData.color;
  allDay = this.eventData.allDay;
  completed = this.eventData.completed;
  editable = this.eventData.editable;
  hasAnswer = this.eventData.hasAnswer;
  EVENTS_COLORS = EVENTS_COLORS;

  repeat = false
  frequency = null
  count = null
  toDelete = false
  range = 'current'

  onSubmit() {
    if (!this.checkTimeValues()) {
      this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.EVENTS.UPDATE_TIME.FAILED.TITLE"),
          text: this.$t("ALERTS.EVENTS.UPDATE_TIME.FAILED.TEXT")
      });
      this.start.hours = moment(this.eventData.start).format('HH:mm').split(':')[0];
      this.start.minutes = moment(this.eventData.start).format('HH:mm').split(':')[1];
      this.end.hours = moment(this.eventData.end).format('HH:mm').split(':')[0];
      this.end.minutes = moment(this.eventData.end).format('HH:mm').split(':')[1];
      return false
    }
    const output = this.createOutputObject();

    if (this.mode == "add") {
      this.$emit("add:event", output);
    } else if (this.mode == "update") {
      this.$emit("update:event", { data: output, fixTimeZone: true });
    }
  }

  checkTimeValues() {
    const start = moment(new Date(`1/1/1999 ${this.start.hours}:${this.start.minutes}`))
    const end = moment(new Date(`1/1/1999 ${this.end.hours}:${this.end.minutes}`))
    return start.isBefore(end)
  }

  changeDeleteState() {
    if (this.toDelete) {
      if (!this.editable) {
        this.editable = true
      }
    } else {
      if (this.completed) {
        this.editable = false
      }
    }
  }

  onCancel() {
    const output = this.createOutputObject();
    if (this.mode == "add") {
      this.$emit("cancel:add:event", output);
    } else if (this.mode == "update") {
      this.$emit("cancel:update:event", output);
    }
  }

  createOutputObject() {

    this.eventData.start = new Date(this.eventData.start)
    this.eventData.start.setHours(this.start.hours, this.start.minutes)
    this.eventData.end = new Date(this.eventData.end)
    this.eventData.end.setHours(this.end.hours, this.end.minutes)
    return {
      uuid: this.uuid,
      title: this.title,
      color: this.color,
      content: this.content,
      start: this.eventData.start,
      end: this.eventData.end,
      id: this.eventData.id || null,
      pagesElementsId: this.eventData.pagesElementsId,
      templatesElementsId: this.eventData.templatesElementsId,
      allDay: this.allDay,
      completed: this.completed,
      resizable: !this.completed,
      repeat: {
        repeatable: this.repeat,
        frequency: this.frequency,
        count: this.count
      },
      toDelete: {
        toDelete: this.toDelete
      },
      applyRange: {
        range: this.range ? this.range : null
      }
    };
  }
}
